var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBproLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "32px",
    viewBox: "0 0 40 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "064129B1-4368-42B6-B206-7EF15C2BA6BC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.132239994 17.0823112 0.132239994 17.0823112 19.3123191 0 19.3123191"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0466559979 0.165119993 15.3070553 0.165119993 15.3070553 13.3281354 0.0466559979 13.3281354"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.0466559979 0.0370919983 15.3070553 0.0370919983 15.3070553 13.1999994 0.0466559979 13.1999994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0 31.2748786 178.689832 31.2748786 178.689832 0.239999989 0 0.239999989"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BProtocol-|-Desktop-HP-Final",
    transform: "translate(-51.000000, -23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(51.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 7.994880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.741671967,9.89159956 L10.5010315,0.132239994 L16.3407113,5.97215973 C17.3295112,6.96095969 17.3295112,8.56415962 16.3407113,9.55319957 L6.58135171,19.3123191 L0.741671967,13.4726394 C-0.247367989,12.4838394 -0.247367989,10.8806395 0.741671967,9.89159956",
    id: "Fill-1",
    fill: "#12C264",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.759999, 0.074880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0466559979,6.7466157 L5.88657574,0.906695959 C6.87537569,-0.0821039963 8.47857562,-0.0821039963 9.46737558,0.906695959 L15.3070553,6.7466157 L9.46737558,12.5865354 C8.47857562,13.5753354 6.87537569,13.5753354 5.88657574,12.5865354 L0.0466559979,6.7466157 Z",
    id: "Fill-4",
    fill: "#12C264",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(11.759999, 18.074879)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0466559979,6.6185517 L5.88657574,0.778871965 C6.87537569,-0.210167991 8.47857562,-0.210167991 9.46737558,0.778871965 L15.3070553,6.6185517 L9.46737558,12.4584714 C8.47857562,13.4472714 6.87537569,13.4472714 5.88657574,12.4584714 L0.0466559979,6.6185517 Z",
    id: "Fill-7",
    fill: "#12C264",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.533047,13.9670154 L32.7280065,3.77205583 L38.5676863,9.61197557 C39.5564862,10.6007755 39.5564862,12.2039755 38.5676863,13.1930154 L28.3729667,23.387735 L22.533047,17.5480552 C21.544247,16.5590153 21.544247,14.9558153 22.533047,13.9670154",
    id: "Fill-10",
    fill: "#12C264"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBproLogo);
export default __webpack_public_path__ + "static/media/BPRO-logo.61a8046a644e44baca0e9ea8dd308955.svg";
export { ForwardRef as ReactComponent };